// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vhallPlayer-time-box {\n  /* font-size: 16px; */\n}\n\n.vhallPlayer-time-box i{\n  font-style: initial;\n  color: #fff;\n  margin: 0 5px;\n}\n\n.vhallPlayer-time-box span.current-time {\n  color: #fff;\n  font-size: 14px;\n}\n\n.vhallPlayer-time-box span.all-time {\n  color: #fff;\n  font-size: 14px;\n}", ""]);
// Exports
module.exports = exports;
